import { render, staticRenderFns } from "./InternalWorkbench.vue?vue&type=template&id=14ba24d8&scoped=true&"
import script from "./InternalWorkbench.vue?vue&type=script&lang=js&"
export * from "./InternalWorkbench.vue?vue&type=script&lang=js&"
import style0 from "./InternalWorkbench.vue?vue&type=style&index=0&id=14ba24d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ba24d8",
  null
  
)

export default component.exports